/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkingEntryType = {
    FreeFlow: 'FreeFlow',
    Gated: 'Gated'
} as const;
export type ParkingEntryType = typeof ParkingEntryType[keyof typeof ParkingEntryType];

